export default 'marketingTrackingPage';
